var $0aa3ceafb597db1b$exports = {};
$0aa3ceafb597db1b$exports = {
    "pending": `odottaa`
};


export {$0aa3ceafb597db1b$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
